import { createBrowserHistory } from "history";

import { trackVisitor } from "./components/utils/util";

const history = createBrowserHistory();
history.listen(() => trackVisitor());

export default history;
